<template>
    <div>
        <div class="recom-icons">
            <div class="recom-icon" @click="godetail(item)">
                <van-icon
                    class="recom-icon-icon2"
                    :size="18"
                    
                    class-prefix="abc-icon"
                    name="pinglun8"
                />
                <span>51</span>
            </div>
            <div class="recom-icon" >
                <van-icon
                    class="recom-icon-icon3"
                    :size="18"
                    class-prefix="abc-icon"
                    name="zan"
                />
                <span>36</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'alloperate',
    props:{
        item:{
            type:Object,
            default:undefined
        }
    },
    data(){
        return {

        }
    },
    created(){

    },
    methods:{
         godetail(item){
            var itemjson=JSON.stringify(item);
            this.$router.push({path:'/recommenddetail',query:{item:itemjson}});
        },
        
    }
}
</script>
<style lang="scss" scoped>
.recom-icons{
    display: flex;
    text-align: center;
    line-height: 25px;
    .recom-icon{
        width: 50%;
    }
    .recom-icon-icon1{
        vertical-align: -2px;
        margin-right: 2px;
    }
    .recom-icon-icon2{
        vertical-align: -1px;
        margin-right: 4px;
    }
    .recom-icon-icon3{
        vertical-align: -1px;
        margin-right: 4px;
    }
}
</style>